<!--<fieldset [formGroup]="formControl" class="table-select-form">-->
<!--  <legend class="sr-only">Change password select</legend>-->
<!--  <tngh-form-section title="password reset" i18n-title="@@passwordResetForm">-->
<!--    <tngh-form-grid>-->
<!--      <tngh-text-input class="span-6" formControlName="newPassword" label="new password" i18n-label="@@newPasswordField"></tngh-text-input>-->
<!--      <tngh-text-input class="span-6" formControlName="confirmPassword" label="confirm password" i18n-label="@@confirmPasswordField"></tngh-text-input>-->
<!--    </tngh-form-grid>-->
<!--  </tngh-form-section>-->
<!--</fieldset>-->

<div class="login-screen">
  <tngh-logo />
  <tngh-form-card>
    <form [formGroup]="formControl" class="form-card-form-wrapper">
      <fieldset>
        <legend class="form-card-form-wrapper__legend" i18n>Reset password</legend>
        <tngh-form-grid>
          <tngh-text-input
            class="span-6"
            formControlName="newPassword"
            label="New password"
            type="password"
            i18n-label="@@newPasswordField"
          ></tngh-text-input>
          <tngh-text-input
            class="span-6"
            formControlName="confirmPassword"
            label="Confirm new password"
            type="password"
            i18n-label="@@confirmPasswordField"
          ></tngh-text-input>
        </tngh-form-grid>
      </fieldset>

      <div class="login-screen__cta">
        <tngh-button
          type="submit"
          [debounceTime]="500"
          (clickEvent)="onSubmit()"
          i18n-label="@@resetPasswordSubmitButton"
          [fullwidth]="true"
          label="Reset password"
          i18n="Reset password button@@ResetPasswordPageButton"
        ></tngh-button>
      </div>
    </form>
  </tngh-form-card>
</div>
